import { css, keyframes } from 'styled-components';

const keyframesFadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

export const cssBackgroundGradient = css`
  background: radial-gradient(
    circle at 0% 0%,
    ${({ theme }) => theme.backgroundGradient.lightColor} 0%,
    ${({ theme }) => theme.backgroundGradient.darkColor} 100%
  );
`;

export const cssBackgroundGradientOverlay = css`
  background: linear-gradient(
    to bottom,
    ${({ theme }) => theme.interaction.recipe950.default} 0%,
    ${({ theme }) => theme.backgroundGradient.darkColor} 50%
  );
`;

export const cssFadeIn = css`
  animation-name: ${keyframesFadeIn};
  animation-duration: ${({ theme }) => theme.animation.duration.tabIndicator};
`;

export const cssFlexCenter = css`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const cssGpu = css`
  transform: translate3d(0, 0, 0);
  z-index: 1;
`;

export const cssInteractive = css`
  cursor: pointer;
  transition: border-color ${({ theme }) => theme.animation.duration.color};
`;

export const cssOutlineNone = css`
  outline: 2px solid transparent;
  outline-offset: 2px;
`;

export const cssOverflowY = css`
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
`;

export const cssScrollbarHidden = css`
  scrollbar-width: none;

  ::-webkit-scrollbar {
    display: none;
  }
`;

export const cssSrOnly = css`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
`;
